import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLang } from '../context/LangContext';

// 导入beforeafter合并图片（before和after已并列排版）
import fillerCombined from '../assets/images/beforeafter/filler.jpg';
import acneCombined from '../assets/images/beforeafter/acne.jpg';
import injectableCombined from '../assets/images/beforeafter/injectable.jpg';
import agingCombined from '../assets/images/beforeafter/liuyang.jpg';
import lucyCombined from '../assets/images/beforeafter/lucy.jpg';
import annaCombined from '../assets/images/beforeafter/suki.jpg';
import lilyCombined from '../assets/images/beforeafter/lily.jpg';
import junieCombined from '../assets/images/beforeafter/junie.jpg';
import elsieCombined from '../assets/images/beforeafter/elsie.jpg';
import elsie2Combined from '../assets/images/beforeafter/elsie2.jpg';
import guyCombined from '../assets/images/beforeafter/guy.png';
import lanaCombined from '../assets/images/beforeafter/leyla.png';
import lillianCombined from '../assets/images/beforeafter/lillian.png';
import eileenCombined from '../assets/images/beforeafter/eileen.jpg';

const content = {
  en: {
    pageTitle: 'Success Cases',
    metaTitle: 'Before & After Treatment Cases | Halo Aesthetic Clinic Richmond Hill',
    pageDesc: 'Real cases to witness beautiful transformations.',
    metaDesc: 'Browse real client before and after aesthetic treatment cases at Halo Aesthetic Clinic Richmond Hill, including skin boosters, dermal fillers, and laser skin rejuvenation.',
    viewDetails: 'View Details',
    before: 'Before',
    after: 'After',
    clientStory: 'Client Story',
    treatmentPlan: 'Treatment Plan',
    duration: 'Duration',
    cases: [
      {
        id: 1,
        title: 'Facial Rejuvenation Case',
        description: 'Comprehensive treatment to improve facial contours and enhance youthfulness.',
        combinedImage: fillerCombined,
        story: 'Emily, 35, showed obvious signs of aging due to work stress. After instant filler treatment, her facial contours improved significantly and she looked much younger.',
        treatment: 'Radiesse + Hyaluronic Acid Filler + Botox Injection',
        duration: 'instant',
      },
      {
        id: 2,
        title: 'Skin Improvement Case',
        description: 'Professional skin care plan to improve skin texture and brighten complexion.',
        combinedImage: acneCombined,
        story: 'Olivia, 28, had dull and rough skin due to long-term late nights. She had a lot of acnes. After 2 months of treatment, her skin texture improved significantly and her complexion became more even and radiant.',
        treatment: 'BBL HERO + HydraFacial + Potenza + PRP',
        duration: '2 months',
      },
      {
        id: 3,
        title: 'Facial Contour Improvement Case',
        description: 'Micro-plastic surgery to improve facial contours and enhance overall aesthetics.',
        combinedImage: injectableCombined,
        story: 'Mia, 29, was not satisfied with her facial contours and skin texture. After 6 month of treatment, her facial contours improved significantly and her overall appearance was enhanced.',
        treatment: 'Hydrafacial + BBL HERO + mesotherapy + sculptra + filler + Ultherapy prime',
        duration: '6 month',
      },
      {
        id: 4,
        title: 'Advanced Skin Smoothing Case',
        description: 'Comprehensive skin treatment to address multiple skin concerns and achieve radiant results.',
        combinedImage: agingCombined,
        story: 'Emma, 35, struggled with uneven skin tone, and premature aging signs. After a personalized treatment plan, her skin achieved remarkable improvement with smoother texture and brighter complexion.',
        treatment: 'BBL HERO * 3',
        duration: '4 months',
      },
      {
        id: 5,
        title: 'Mid-Face Contouring & Structural Rejuvenation',
        description: 'Multi-layer injection technique targeting the mid-face and periorbital area for a lifted, refreshed appearance.',
        combinedImage: lucyCombined,
        story: 'Lucy, 27, sought to address a tired appearance caused by deep tear troughs and flattening of the mid-face. By combining Hyaluronic Acid and Radiesse for delicate volume and Radiesse for structural support in the nose and nasolabial folds, her "Double C" orbital area was revitalized, restoring a youthful, rested contour.',
        treatment: 'HA (Tear Troughs/Double C) + Radiesse (Nose/Nasolabial Folds)',
        duration: '1.5 hours',
      },
      {
        id: 6,
        title: 'Age Spot Removal & Skin Rejuvenation',
        description: 'Advanced PicoSure Pro laser treatment targeting age spots and uneven pigmentation to restore a clearer, brighter complexion.',
        combinedImage: annaCombined,
        story: 'Anna, 38, began noticing age spots and uneven pigmentation developing on her cheeks and temples, which made her skin look dull and prematurely aged. She underwent a single session of PicoSure Pro laser treatment, which uses ultra-short picosecond pulses to break down pigmentation while stimulating natural collagen renewal. After the treatment, her age spots were significantly lightened, and her overall complexion appeared clearer, brighter, and more refreshed.',
        treatment: 'PicoSure Pro (Age Spot & Pigmentation Removal)',
        duration: '45 minutes',
      },
      {
        id: 7,
        title: 'PicoSure Pro + Whitening Meso Case',
        description: 'Combined laser and mesotherapy for brighter, smoother skin after pigmentation and dullness concerns.',
        combinedImage: lilyCombined,
        story: 'Lily, 29, had visible spots and a dull complexion that made her skin look tired. After one session of PicoSure Pro to target pigmentation and one whitening mesotherapy session to hydrate and brighten, her skin appeared more even, clearer, and softly radiant with a refined texture.',
        treatment: 'PicoSure Pro × 1 + Whitening Meso × 1',
        duration: 'Single combined session',
      },
      {
        id: 8,
        title: 'Shoulder & Body Contouring Case',
        description: 'Strategic body filler injections to refine the shoulder line and create a smoother, more sculpted “right-angle shoulder” silhouette.',
        combinedImage: junieCombined,
        story: 'Jay wanted a cleaner shoulder profile and a more defined transition from neck to shoulder for an elegant upper-body silhouette. With carefully placed body filler to support and reshape the shoulder contour, her line appeared smoother and more lifted, enhancing overall body proportion while keeping a natural look.',
        treatment: 'Body Filler Injection (Shoulder Reshaping / Right-Angle Shoulder)',
        duration: 'Single session',
      },
      {
        id: 9,
        title: 'PicoSure Pro + Mesotherapy Skin Renewal Case',
        description: 'Dual PicoSure Pro sessions with mesotherapy for brighter, smoother, deeply hydrated skin.',
        combinedImage: elsieCombined,
        additionalImages: [elsie2Combined],
        story: 'Elsa had dull, uneven skin with a rough texture. After two PicoSure Pro sessions to refine tone and texture, plus two mesotherapy treatments for deep hydration and brightening, her skin became noticeably softer, smoother, and more radiant—with a clearer, moisturized glow.',
        treatment: 'PicoSure Pro × 2 + Mesotherapy × 2',
        duration: 'Multi-session course',
      },
      {
        id: 10,
        title: 'HarmonyCa Jawline Contouring Case',
        description: 'Dual HarmonyCa injections to sculpt and define the jawline for a sharper, more structured lower-face profile.',
        combinedImage: guyCombined,
        story: 'Jason wanted a more defined jawline and clearer lower-face contour. After two HarmonyCa sessions targeting the jaw and chin area, his jawline appeared noticeably sharper and more sculpted, with improved facial structure while maintaining a natural look.',
        treatment: 'HarmonyCa × 2',
        duration: 'One session',
      },
      {
        id: 11,
        title: 'Juvederm HA Filler - Nasal Bridge & Medial Orbital Rim (Double C)',
        description: 'Targeted Juvederm hyaluronic acid filler treatment for nasal bridge elevation and medial orbital rim rejuvenation.',
        combinedImage: lanaCombined,
        story: 'Lana wanted to address tear trough hollows and enhance her nasal bridge contour. With 2 syringes of Juvederm Hyaluronic Acid filler in a single treatment, her medial orbital rim ("Double C" area) was smoothly restored and her nasal bridge naturally lifted for a refreshed, elegant look.',
        treatment: 'Juvederm Hyaluronic Acid Filler × 2 Syringes (Nasal Bridge & Medial Orbital Rim / Double C)',
        duration: 'Single treatment',
      },
      {
        id: 12,
        title: 'Hyaluronic Acid Nose Contouring Case',
        description: 'Hyaluronic acid injection to elevate the nose bridge and define the nose tip.',
        combinedImage: lillianCombined,
        story: 'Lillian wanted to enhance her nasal profile. By injecting one syringe of hyaluronic acid into the nose, her nose bridge looks higher and her nose tip is more upturned, resulting in a more refined and sculpted look.',
        treatment: 'JuvedermHyaluronic Acid Filler × 1 Syringe (Nose Contouring)',
        duration: 'Single treatment',
      },
      {
        id: 13,
        title: 'BBL HERO Redness & Acne Scar Reduction Case',
        description: 'Two rounds of BBL HERO treatment to reduce facial redness and fade acne scars, with remarkable results.',
        combinedImage: eileenCombined,
        story: 'Eileen struggled with persistent facial redness and stubborn acne scars that affected her confidence. After two targeted BBL HERO sessions, the redness was visibly calmed and her acne scars faded significantly — revealing a clearer, more even, and refreshed complexion. She was thrilled with how natural and lasting the improvements looked.',
        treatment: 'BBL HERO × 2 (Redness Reduction & Acne Scar Fading)',
        duration: 'Two sessions',
      },
    ],
  },
  cn: {
    pageTitle: '成功案例',
    metaTitle: '医美真实效果案例对比 | Halo Richmond Hill 医美诊所',
    pageDesc: '真实案例展示，见证美丽蜕变',
    metaDesc: '查看 Halo Richmond Hill 医美诊所真实客户治疗前后对比案例，涵盖玻尿酸填充、水光针、超声炮与激光皮肤修复效果。',
    viewDetails: '查看详情',
    before: '治疗前',
    after: '治疗后',
    clientStory: '客户故事',
    treatmentPlan: '治疗方案',
    duration: '治疗周期',
    cases: [
      {
        id: 1,
        title: '面部年轻化案例',
        description: '通过综合治疗方案，改善面部轮廓，提升整体年轻感。',
        combinedImage: fillerCombined,
        story: 'Emily，35岁，因工作压力大，面部出现明显衰老迹象。玻尿酸注射项目的即时效果，面部轮廓得到明显改善，整体年轻感提升。',
        treatment: '微晶瓷提升 + 玻尿酸填充 + 肉毒素注射',
        duration: '即时',
      },
      {
        id: 2,
        title: '皮肤改善案例',
        description: '通过专业皮肤护理方案，改善肤质，提亮肤色。',
        combinedImage: acneCombined,
        story: 'Olivia，28岁，因长期熬夜导致皮肤暗沉、粗糙。长期发炎性痘痘。经过2个月的治疗，肤质得到明显改善，肤色更加均匀透亮。',
        treatment: '光子嫩肤 + 海菲秀 + 黄金微针 + PRP',
        duration: '2个月',
      },
      {
        id: 3,
        title: '面部轮廓改善案例',
        description: '通过微整形技术，改善面部轮廓，提升整体美感。',
        combinedImage: injectableCombined,
        story: 'Mia，29岁，希望改善面部轮廓不够立体，改善肤质和整体形象。经过6个月的治疗，面部轮廓得到明显改善，整体美感提升。',
        treatment: '海菲秀 + BBL HERO + 水光针 + 童颜针 + 玻尿酸 + 超声刀prime',
        duration: '6个月',
      },
      {
        id: 4,
        title: '高级皮肤焕新案例',
        description: '通过综合皮肤治疗方案，解决多种皮肤问题，获得光彩照人的效果。',
        combinedImage: agingCombined,
        story: 'Emma，35岁，长期受肤色不均和早衰迹象困扰。经过个性化治疗方案，皮肤获得显著改善，质地更加光滑，肤色更加明亮。',
        treatment: 'BBL HERO * 3',
        duration: '4个月',
      },
      {
        id: 5,
        title: '中面部精雕与眼周立体年轻化',
        description: '多层次注射方案，精准修饰眼周及中面部，打造自然流露的饱满与立体感。',
        combinedImage: lucyCombined,
        story: '27岁的Lucy受泪沟凹陷和初老纹路困扰，显得倦怠不显精神。通过眼眶“双C位”的精细平铺与鼻基底、法令纹的结构性支撑，整体面部线条得到了即刻提升，不仅修饰了鼻部轮廓，更重塑了饱满、年轻的视觉中心。',
        treatment: '玻尿酸 (泪沟/眼眶双C) + 微晶瓷 (隆鼻/法令纹填充)',
        duration: '1.5 小时',
      },
      {
        id: 6,
        title: '晒斑淡化与肤色焕亮',
        description: '使用PicoSure Pro皮秒激光精准针对日晒形成的色素沉着，帮助恢复更加均匀、透亮的肤色。',
        combinedImage: annaCombined,
        story: 'Anna，38岁，由于长期日晒，面颊和太阳穴逐渐出现明显的晒斑与色素沉着，使肤色看起来暗沉、缺乏光泽。她接受了一次PicoSure Pro皮秒激光治疗，通过超短皮秒脉冲能量精准击碎色素颗粒，同时刺激皮肤胶原更新。治疗后，她的晒斑明显淡化，整体肤色更加均匀透亮，皮肤看起来更加清新年轻。',
        treatment: 'PicoSure Pro 皮秒激光（晒斑 / 色素沉着改善）',
        duration: '45分钟',
      },
      {
        id: 7,
        title: 'PicoSure Pro + 美白水光联合案例',
        description: '皮秒联合美白水光，改善斑点暗沉，呈现更均匀透亮、细腻柔嫩的肤质。',
        combinedImage: lilyCombined,
        story: 'Lily，29岁，面部有明显斑点、肤色暗沉，整体显得缺乏光泽。她各接受一次 PicoSure Pro 皮秒激光与美白水光治疗：皮秒帮助击碎色素、改善色沉，美白水光补充水分与亮肤成分。治疗后肤色更均匀透亮，肤质更细腻，呈现自然的美白嫩肤效果。',
        treatment: 'PicoSure Pro × 1 + 美白水光 × 1',
        duration: '单次联合疗程',
      },
      {
        id: 8,
        title: '肩型身体塑形 · 直角肩重塑',
        description: '通过身体填充剂注射修饰肩部线条，改善溜肩或线条不清晰，打造更利落、立体的直角肩轮廓。',
        combinedImage: junieCombined,
        story: 'Jay 希望改善肩颈衔接处线条，让肩部看起来更平整、有支撑感，整体比例更修长。医生根据她的骨架与肌肉走向，以身体填充剂进行分层塑形，柔化斜方肌外侧视觉、加强肩峰表现点，术后肩线更流畅，直角肩轮廓更自然协调。',
        treatment: '身体填充剂注射（肩部塑形 / 直角肩重塑）',
        duration: '单次治疗',
      },
      {
        id: 9,
        title: 'PicoSure Pro + 水光嫩肤联合案例',
        description: '两次皮秒联合两次水光，改善肤质暗沉粗糙，呈现嫩白光滑、水润透亮的肌肤状态。',
        combinedImage: elsieCombined,
        additionalImages: [elsie2Combined],
        story: 'Elsa 原本肤色暗沉、肤质粗糙。她先后完成两次 PicoSure Pro 皮秒激光与两次水光针治疗：皮秒帮助改善色沉、细腻肤质，水光深层补水亮肤。治疗后皮肤明显变得嫩白光滑，保湿感提升很多，整体透亮有光泽。',
        treatment: 'PicoSure Pro × 2 + 水光针 × 2',
        duration: '多疗程联合',
      },
      {
        id: 10,
        title: 'HarmonyCa 美神针下颌线塑形案例',
        description: '两次美神针注射，精准塑形下颌线，打造更清晰、立体的下脸部轮廓。',
        combinedImage: guyCombined,
        story: 'Jason 希望改善下颌线不够清晰的问题，让下脸部轮廓更有立体感。他先后完成两次 HarmonyCa 美神针治疗，针对下颌与下巴区域进行结构性支撑与塑形。治疗后下颌线明显更加立体清晰，整体脸型线条更利落，同时保持自然协调。',
        treatment: 'HarmonyCa 美神针 × 2',
        duration: '一次疗程',
      },
      {
        id: 11,
        title: '乔雅登玻尿酸填充鼻背与眼眶内双C案例',
        description: '使用乔雅登玻尿酸精准填充鼻背与眼眶内双C区域，改善眼周凹陷与鼻部轮廓。',
        combinedImage: lanaCombined,
        story: 'Lana希望改善眼眶内双C区域凹陷与鼻背轮廓。通过单次治疗使用2只乔雅登玻尿酸，精细平铺于眼眶内双C区域并支撑鼻背，即刻提升眼周饱满度与鼻部立体感，整体面部显得更加年轻清新、自然协调。',
        treatment: '乔雅登玻尿酸 × 2只（鼻背填充 + 眼眶内双C）',
        duration: '单次治疗',
      },
      {
        id: 12,
        title: '玻尿酸注射隆鼻与鼻头塑形案例',
        description: '使用玻尿酸精准注射，垫高山根并修饰鼻头，使鼻部线条更挺翘。',
        combinedImage: lillianCombined,
        story: 'Lillian为了改善鼻部形状，注射了一支乔雅登玻尿酸，让山根看上去更加高挺，鼻头更加精致。治疗后鼻部立体感显著增强，面部轮廓更加精致自然。',
        treatment: '乔雅登玻尿酸 × 1支（鼻部塑形）',
        duration: '单次治疗',
      },
      {
        id: 13,
        title: 'BBL HERO 去红祛痘印案例',
        description: '两次 BBL HERO 光子嫩肤治疗，有效改善面部泛红与痘印，效果显著。',
        combinedImage: eileenCombined,
        story: 'Eileen 长期被顽固的面部泛红和痘印所困扰，严重影响了她的自信心。经过两次 BBL HERO 光子嫩肤治疗，面部泛红明显减退，痘印显著淡化，肤色更加均匀透亮，整体肤质焕然一新。Eileen 对治疗效果非常满意，自然持久的改善让她重拾了自信。',
        treatment: 'BBL HERO × 2（去红 / 祛痘印）',
        duration: '两次疗程',
      },
    ],
  }
};

const Cases = () => {
  const { lang } = useLang();
  const c = content[lang];
  const [selectedCase, setSelectedCase] = useState(null);

  const canonicalUrl = 'https://www.haloaestheticclinic.com/cases';

  return (
    <div className="bg-softGradient bg-no-repeat bg-top text-text">
      <Helmet>
        <title>{c.metaTitle}</title>
        <meta name="description" content={c.metaDesc} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={c.metaTitle} />
        <meta property="og:description" content={c.metaDesc} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-section">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 text-gray-900">{c.pageTitle}</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">{c.pageDesc}</p>
        </div>

        {/* 案例列表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {c.cases.map((caseItem) => (
            <div
              key={caseItem.id}
              className="bg-white/80 backdrop-blur-sm rounded-xl shadow-card overflow-hidden cursor-pointer border border-champagne/40 hover:shadow-glow transition-all"
              onClick={() => setSelectedCase(caseItem)}
            >
              <div className="relative">
                <img
                  src={caseItem.combinedImage}
                  alt={caseItem.title}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center">
                  <span className="text-white text-lg font-semibold bg-[#2E6B4C]/80 px-4 py-2 rounded-xl">
                    {c.viewDetails}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-900">{caseItem.title}</h3>
                <p className="text-gray-700">{caseItem.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 案例详情弹窗 */}
        {selectedCase && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white/95 backdrop-blur-md rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-champagne/40 shadow-glow">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">{selectedCase.title}</h2>
                  <button
                    onClick={() => setSelectedCase(null)}
                    className="text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="mb-6 space-y-4">
                  <img
                    src={selectedCase.combinedImage}
                    alt={selectedCase.title}
                    className="w-full rounded-xl object-contain border border-champagne/40"
                  />
                  {selectedCase.additionalImages?.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`${selectedCase.title} ${index + 2}`}
                      className="w-full rounded-xl object-contain border border-champagne/40"
                    />
                  ))}
                </div>

                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold mb-2 text-[#2E6B4C]">{c.clientStory}</h3>
                    <p className="text-gray-700">{selectedCase.story}</p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2 text-[#2E6B4C]">{c.treatmentPlan}</h3>
                    <p className="text-gray-700">{selectedCase.treatment}</p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2 text-[#2E6B4C]">{c.duration}</h3>
                    <p className="text-gray-700">{selectedCase.duration}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cases; 